import {round} from './round';

const roundTo3DecimalPlaces = round(3);

export {roundTo3DecimalPlaces};
